<template lang="pug">
	<div>
		<b-button v-if="!d_paused" variant="success" title="Microphone on" @click="m_toggleMicrophone"><fa-icon  icon="microphone" /></b-button>
		<b-button v-if="d_paused" variant="danger" title="Microphone off" @click="m_toggleMicrophone"><fa-icon icon="microphone-slash"  /></b-button>
	</div>
</template>
<script>
import { eventBus } from '@/main';
export default {
	name: "kt-voice-component",
	components: {},
	created() {},
	mounted() {
	
			console.log('document.getElementsByTagName VoiceComponent');
			console.log(document.getElementsByTagName('input'));
			Array.from(document.getElementsByTagName('input')).forEach(i=>
								{
								console.log(i.id);
								var _this=this;
								i.addEventListener("focus", (event) => {
								console.log(`focus on ${i.id}`);
								console.log(`SelectionStart:${i.selectionStart}`);
								this.$emit("focused",i.id);
								});
								
								});
								
			Array.from(document.getElementsByTagName('textarea')).forEach(i=>
								{
								console.log(i.id);
								var _this=this;
								i.addEventListener("focus", (event) => {
								console.log(`focus on ${i.id}`);
								console.log(`SelectionStart:${i.selectionStart}`);
								this.$emit("focused",i.id);
								});
								
								});
								
				//document.getElementById('foobar').addEventListener('keyup', e => {
				//console.log('Caret at: ', e.target.selectionStart)
				//})
								

			
	
	},
	data() {
		return {
			d_paused: true,
			d_speechRecognizer: null,
			d_currentSentence:null,
			d_last_focus:null,
		};
	},
	props: {},
	computed: {},
	methods: {
	m_next(){     
			//var enabledInputs = $("input:enabled");
			var idx = this.p_formEnabledFields.index(this);
			this.p_formEnabledFields.eq(idx+1).focus()
	},
	m_previous(){     
			var enabledInputs = $("input:enabled");
			var idx = this.p_formEnabledFields.index(this);
			this.p_formEnabledFields.eq(idx+1).focus()
	},
    m_toggleMicrophone() {
      this.d_paused = !this.d_paused;
      if(!this.d_paused) this.m_getSpeech();
      if(this.d_paused&&this.d_speechRecognizer) this.d_speechRecognizer.stop();
    },
    m_getSpeech() {
	
	
      if (!this.d_paused) {
        this.d_speechRecognizer = new webkitSpeechRecognition();
        this.d_speechRecognizer.continuous = true;
        this.d_speechRecognizer.interimResults = true;
        this.d_speechRecognizer.lang = 'en-US';
        this.d_speechRecognizer.start();

	
        var finalTranscripts =null;

        this.d_speechRecognizer.onresult = (event) => {
          var interimTranscripts = '';
          for (var i = event.resultIndex; i < event.results.length; i++) {
            var result = event.results[i];
            for (var j = result.length - 1; j >= 0; j--) {
              var word = result[j].transcript.trim();
              if (word !== "") {

                if (result.isFinal && result[0].confidence > 0.1) {
                  this.m_toggleMicrophone();
                  finalTranscripts += this.m_filterSingleQuotes(word) + ' ';
                } else {
                  interimTranscripts += this.m_filterSingleQuotes(word) + ' ';
                }

              }
            }
          }
			if(finalTranscripts) {
				var currentSentence = finalTranscripts.trim().replace('null','');
				//currentSentence=currentSentence[0].toUpperCase() + currentSentence.slice(1);
				currentSentence=currentSentence.replace(/^./, (x) => x.toUpperCase());
				//if(currentSentence) this.m_processSentence(currentSentence);
				if(currentSentence) this.$emit('voice',currentSentence);
				}
        };
        this.d_speechRecognizer.onerror = function (event) {
          console.log('Unable to load the listener.');
        };
      }
    },
	m_processSentence(sentence){
	
	//go to , repeat, save, cancel, next(nextElementSibling), previous(previousElementSibling),edit
		if(sentence=='repeat') {
			eventBus.$emit('fieldText', '');
		}
		else if("/^(go to)/.test(sentence)"){
				var field=sentence.replace(/\s/g, '');
				field==sentence.replace(/goto/, '');
				eventBus.$emit('goto', field);
			}
		else if(sentence=='next') {
				eventBus.$emit('next', '');
		 }
		else if(sentence=='save') {
				eventBus.$emit('save', '');
		 }
		else if(sentence=='cancel') {
				eventBus.$emit('cancel', '');
		}
		else {
			eventBus.$emit('captured',sentence);
			}
		 
	},
    m_filterSingleQuotes(text) {
      return text.replace(/'/g, '');
    },
	},
watch: {}		
};
</script>
<style scoped lang="less">
input:focus {
  background-color: lightblue;
  color:blue;
}

select:focus {
  background-color: ivory;
  color:blue;
}

</style>